
export const hoursData = Array.from({ length: 9 }, (_, i) => ({
  label: `${i} hour`,
  value: i ,
}));

export const minutesData = [
  { label: "00", value: 0 },
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
];

export const activityTypes = [
  { label: "Fresh", value: "FRESH" },
  { label: "Rework", value: "REWORK" },
];
